import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// React Router preserves scroll position across client-side navigations, so
// without this, visitors land mid-page on ICP and case-study pages. Hash
// targets retry briefly because sections mount after lazy routes resolve.
// Back/forward (POP) keeps the browser's native scroll restoration.
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (!hash) {
      if (navigationType !== "POP") window.scrollTo(0, 0);
      return;
    }
    const id = hash.slice(1);
    let attempts = 0;
    let timer;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
      else if (attempts++ < 20) timer = setTimeout(tryScroll, 100);
    };
    tryScroll();
    return () => clearTimeout(timer);
  }, [pathname, hash, navigationType]);

  return null;
};

export default ScrollToTop;
